import styled from 'styled-components';
import * as themeStyled from 'react-tabtab/lib/themes/bulma';

let { TabList, ActionButton, Tab, Panel } = themeStyled;

TabList = styled(TabList)`
    background-color: transparent
    height:48px
    &:hover {
        color: white;
    }
`;

Tab = styled(Tab)`
    border-left: solid 1px rgba(72, 94, 144, 0.16);
    border-right: solid 1px rgba(72, 94, 144, 0.16);
    border-top: solid 1px rgba(72, 94, 144, 0.16);
    border-bottom: none;
    ${props => props.active ?
    ` background-color: #DDDDDD;` : null}
        &::after{
            background: none;
        }
`;

ActionButton = styled(ActionButton)`
    font-size: 25px;
    padding: 0px;
    color: black;
    background-color: transparent;
    &:hover {
        background-color: #eee;
    }
`;

Panel = styled(Panel)`
    padding: 0px !important;
    background-color: transparent
`;

export default {
    TabList: TabList,
    ActionButton: ActionButton,
    Tab: Tab,
    Panel: Panel
}
